import axios from "axios";
import { v4 as uuidv4 } from 'uuid';

export const validateZip = async (zipcode, widgetId) => {
    try {
        const TARGET_URL = `${process.env.REACT_APP_PROFILE_ACCESSOR_XAPI_URL}/zip-validation?zipcode=${zipcode}&id=${widgetId}`;
        const INVOKE_XAPI_CONFIG = {
            headers: {
                'Content-Type': 'application/json',
                'X-TRV-APPLICATION': process.env.REACT_APP_X_APP_NAME,
                'X-TRV-APPLICATION-VERSION': '1.0.0',
                'X-TRV-TRANSACTION-ID': uuidv4(),
                'X-TRV-APPLICATION-ENV': process.env.REACT_APP_ENVIRONMENT
                
        }
    }
        const res = await axios.get(TARGET_URL, INVOKE_XAPI_CONFIG);
        return res.data;
    } catch (e) {
        console.log(e);
        
    }
}